import { createAppAsyncThunk } from '../appAsyncThunk';
import { SignUp, ConfirmSignUpBody, EmployerInfo } from './types';
import { setIsLoggedIn } from '../auth/slice';
import { setSignUpStep } from './slice';
import { post } from 'aws-amplify/api';
import {
    signIn,
    signUp,
    AuthError,
    autoSignIn,
    confirmSignUp,
    resendSignUpCode,
    updateUserAttributes,
    confirmUserAttribute,
    sendUserAttributeVerificationCode,
} from 'aws-amplify/auth'

export const checkSignUpThunk = createAppAsyncThunk(
    'signUp/checkSignUpThunk', async (username: string, { dispatch, rejectWithValue }) => {
        try {
            const res = await signIn({ username, password: '123' });
            if (res.nextStep.signInStep === 'CONFIRM_SIGN_UP') {
                dispatch(resendEmailConfirmationCodeThunk(username));
            }
        } catch (e: any) {
            switch (e?.message) {
                case 'User does not exist.':
                    dispatch(setSignUpStep('createPassword'));
                    return rejectWithValue('');
                case 'Incorrect username or password.':
                    return rejectWithValue('This user has already exist.');
                default:
                    return rejectWithValue('Somthing went wrong. Please try again');
            }
        }
    });


export const signUpThunk = createAppAsyncThunk(
    'signUp/signUpThunk', async ({ username, password }: SignUp, { rejectWithValue }) => {
        try {
            const response = await signUp({
                username,
                password,
                options: {
                    autoSignIn: true,
                    userAttributes: {
                        phone_number: ''
                    }
                }
            });
            return response.userId;
        } catch (e: unknown) {
            if (e instanceof Error) {
                return rejectWithValue(e.message);
            }
        }
    });

export const confirmPhoneNumberThunk = createAppAsyncThunk(
    'signUp/confirmPhoneNumberThunk', async (confirmationCode: string, { rejectWithValue }) => {
        try {
            await confirmUserAttribute({ userAttributeKey: 'phone_number', confirmationCode });
        } catch (e: unknown) {
            if (e instanceof Error) {
                return rejectWithValue(e.message);
            } else {
                return rejectWithValue('Somthing went wrong. Please try again');
            }
        }
    });

export const confirmSignUpThunk = createAppAsyncThunk(
    'signUp/confirmSignUpThunk', async ({ username, confirmationCode, mode }: ConfirmSignUpBody, { dispatch, rejectWithValue }) => {
        try {
            const response = await confirmSignUp({ username, confirmationCode });
            const resp = await autoSignIn();
            if (resp.nextStep.signInStep === 'DONE') {
                localStorage.setItem('auth_status', 'Authenticated');

                if (mode === 'Member') {
                    dispatch(setSignUpStep('memberInfo'));
                    dispatch(setIsLoggedIn(true));
                } else {
                    dispatch(setSignUpStep('employerInfo'));
                }


                return response.userId;
            } else {
                dispatch(setSignUpStep('useSignInForm'));
                return rejectWithValue('');
            }
        } catch (e: unknown) {
            if (e instanceof AuthError) {
                if (e.name === 'AutoSignInException') {
                    dispatch(setSignUpStep('useSignInForm'));
                    return;
                } else {
                    return rejectWithValue(e.message);
                }
            } else {
                return rejectWithValue('Somthing went wrong. Please try again');
            }
        }
    });

export const resendEmailConfirmationCodeThunk = createAppAsyncThunk(
    'signUp/resendConfirmationCodeThunk', async (username: string) => {
        const response = await resendSignUpCode({ username });
        return response;
    });

export const resendPhoneNumberConfirmationCodeThunk = createAppAsyncThunk(
    'signUp/resendPhoneNumberConfirmationCodeThunk', async () => {
        const response = await sendUserAttributeVerificationCode({ userAttributeKey: 'phone_number' })
        return response;
    });

export const setProfileDataThunk = createAppAsyncThunk(
    'signUp/setProfileDataThunk', async (body: any, { dispatch }) => {

        const restOperation = post({
            apiName: 'emrProfile',
            path: '/emrProfile/{proxy+}',
            options: { body }
        });

        const response = await restOperation.response;
        dispatch(setIsLoggedIn(true));
        return response.body.json();
    });

export const updateUserAttributesThunk = createAppAsyncThunk(
    'signUp/updateUserAttributesThunk', async (userAttributes: EmployerInfo, { rejectWithValue }) => {
        try {
            const attributes: any = {
                address: userAttributes.address,
                family_name: userAttributes.lastName,
                given_name: userAttributes.firstName,
            };

            if (userAttributes.phoneNumber) {
                attributes.phone_number = userAttributes.phoneNumber
            }

            const response = await updateUserAttributes({
                userAttributes: { ...attributes }
            });

            return response.phone_number?.nextStep.updateAttributeStep === 'CONFIRM_ATTRIBUTE_WITH_CODE';
        } catch (e: unknown) {
            if (e instanceof Error) {
                return rejectWithValue(e.message);
            } else {
                return rejectWithValue('Somthing went wrong. Please try again');
            }
        }
    });